<template>
  <div class="yxp-uploader">
    <slot name="overTips" />
    <button
      v-if="fileBtn"
      class="btn upload-btn"
      :class="className"
      type="button"
      @click.stop.prevent="handleClick"
    >
      {{ btnName }}
    </button>
    <input
      :id="uploaderId"
      ref="input"
      type="file"
      name="yxpuploader"
      :multiple="multiple"
      :accept="accept"
      :limit="limit"
      :capture="capture"
      @change="handleChange"
    >
    <slot name="underTips" />

    <YxpUploadList
      v-if="showList"
      ref="uploadList"
      :list="fileList"
      :retry-upload="retryUpload"
      type="uploadAliResume"
    />
  </div>
</template>

<script>
// 每次上传的字节数
import './aliyun-oss-sdk-6.18.0.min.js';
import { api4 } from './api.js';
const oneMB = 1048576; // 1MB 的 字节数
export default {
    name: 'UploadAliResume',
    props: {
        'uploaderId': {
            type: String,
            required: true,
        },
        'theme': {
            type: String,
            required: false,
            default: '',
        },
        'accept': {
            type: String,
            required: false,
            default: '',
        },
        'showList': {
            type: Boolean,
            required: false,
            default: true,
        },
        'fileList': {
            type: Array,
            required: true,
            default () {
                return [];
            },
        },
        'btnName': {
            type: String,
            required: false,
            default: '请选择文件',
        },
        'className': {
            type: String,
            required: false,
            default: '',
        },
        'autoUpload': {
            type: Boolean,
            required: false,
            default: false,
        },
        'maxSize': {
            type: Number,
            required: false,
            default: 1024 * 10, // 单位kb
        },
        'fileBtn': {
            type: Boolean,
            required: false,
            default: true,
        },
        'uploadModeType': {
            type: String,
            required: false,
            default: '',
        },
        'uploadUrl': {
            type: String,
            required: false,
            default: '/file',
        },
        // 多媒体动作（json字符串）
        'multimedia': {
            type: String,
            required: false,
            default: '',
        },
        'capture': {
            type: String,
            required: false,
            default: undefined,
        },
        'uploadConfig': {
            type: Array,
            required: false,
            default () {
                return [];
            },
        },
        'limit': {
            type: Number,
            required: false,
            default: 1,
        },
    },
    data () {
        return {
            fails: [],
        };
    },
    computed: {
        multiple () {
            return this.limit > 1;
            // return false;
        },
        readyList () {
            return this.fileList.filter(r => {
                return r.status === 'ready';
            });
        },
        uploadingList () {
            return this.fileList.filter(r => {
                return r.status === 'uploading';
            });
        },
    },
    mounted () {

    },
    methods: {
        showMaxSize (maxSize) {
            if (maxSize <= 1024) {
                return maxSize + 'KB';
            } else {
                return Math.round(maxSize / 1024).toFixed(1) + 'MB';
            }
        },
        checkType (rawFile) {
            let accept = this.accept.toLowerCase();
            let accept_ = [];
            if (this.uploadConfig.length) {
                this.uploadConfig.map(r => {
                    r.accept && accept_.push(r.accept);
                });
            }
            accept_ && (accept = accept.toString());
            var extName = rawFile.name.substring(rawFile.name.lastIndexOf('.') + 1);
            extName = extName.toLowerCase();

            var s2 = accept.toLowerCase();
            s2 = s2.replace(/(\.|\*|image\/|video\/|audio\/)/ig, '');
            s2 = s2.split(',');

            var s3 = accept_.toString().toLowerCase();
            s3 = s3.replace(/(\.|\*|image\/|video\/|audio\/)/ig, '');
            s3 = s3.split(',');

            if (s2.indexOf(extName) !== -1 || s3.indexOf(extName) !== -1) {
                return true;
            } else {
                console.log(s2, s3, extName);
                return false;
            }
        },
        // 格式化 filelist
        formatFileList (upFiles) {
            var that = this;
            var item;
            let uploadConfig = null;
            let extName = '';
            let auth = true;
            for (var i = 0; i < upFiles.length; i++) {
                item = upFiles[i];
                // 取配置
                extName = item.name.substring(item.name.lastIndexOf('.') + 1);
                uploadConfig = this.uploadConfig.find(r => {
                    let acc = r.accept.toLowerCase();
                    acc = acc.replace(/(\.|\*|image\/|video\/|audio\/)/ig, '');
                    acc = acc.split(',');
                    return acc.includes(extName.toLowerCase());
                });

                // 判断后缀，格式不对报错，并执行下一条
                if (!this.checkType(item)) {
                    let errorTip = '文件【' + item.name + '】格式不对';
                    this.fails.push({ 'status': 'fail', 'tips': errorTip, 'errType': 'err_type', rawFile: item });
                    continue;
                }
                // 判断大小，0kb报错，并执行下一条
                if (item.size <= 0) {
                    let errorTip = '空文件，上传失败';
                    this.fileList.push({ 'status': 'empty', 'tips': errorTip, 'errType': 'empty_file', rawFile: item });

                    continue;
                }

                // 判断大小，超大就报错，并执行下一条
                if (item.size > (uploadConfig && uploadConfig.maxSize ? 1024 * uploadConfig.maxSize : 1024 * this.maxSize)) {
                    let errorTip = '文件【' + item.name + '】大小超过' + this.showMaxSize((uploadConfig && uploadConfig.maxSize || this.maxSize));
                    this.fails.push({ 'status': 'fail', 'tips': errorTip, 'errType': 'over_max_size', rawFile: item });

                    continue;
                }

                // 文件名长度，超长就报错，并执行下一条
                if (uploadConfig && uploadConfig.fileNameLimit && item.name.replace('.' + extName, '').length > uploadConfig.fileNameLimit) {
                    let errorTip = '文件名【' + item.name + '】超过' + uploadConfig.fileNameLimit + '个字符';
                    this.fails.push({ 'status': 'fail', 'tips': errorTip, 'errType': 'over_name_limit', rawFile: item });
                    continue;
                }

                // 判断数量，超量就报错，并停止执行
                if (this.fileList.length >= this.limit) {
                    let errorTip = '文件数量不能超过' + this.limit + '个';
                    this.fails.push({ 'status': 'fail', 'tips': errorTip, 'errType': 'over_max_limit', rawFile: item });
                    break;
                }

                /*
                // 在列表中找不到相同文件加入
                getMd5(item).then(md5 => {
                    if (that.fileList.findIndex((one) => { return one.md5 !== md5; }) !== -1) {
                        that.fileList.push({ rawFile: item, url: '', md5: '', status: 'ready', progress: 0, downUrl: '', tips: '', result: {} });
                    }
                });
                */

                if (uploadConfig) {
                    auth = typeof uploadConfig.auth !== 'undefined' ? uploadConfig.auth : true;
                }

                // 把所选文件都加入列表
                let options = {
                    onSucc: this.onSucc,
                    onFail: this.onFail,
                    uploadModeType: (uploadConfig && uploadConfig.uploadModeType) || this.uploadModeType,
                    multimedia: (uploadConfig && uploadConfig.multimedia) || this.multimedia,
                    auth: auth,
                };
                that.fileList.push({ rawFile: item, url: '', md5: '', status: 'ready', currentUpSize: 0, progress: 0, downUrl: '', tips: '', result: {}, options: options });
            }
            this.$refs.input.value = null;
        },
        handleClick () {
            this.$refs.input.click();
        },
        handleChange (e) {
            let files = e.target.files;
            this.fails = [];
            if (!files) return;

            let upFiles = Array.prototype.slice.call(files);
            if (upFiles.length === 0) { return; }
            console.log('handleChange', upFiles, upFiles[0].name);

            // this.fileList.splice(0);
            this.formatFileList(upFiles);
            this.$emit('onChange', this.fileList);
            if (this.fails.length) {
                this.fails.forEach(item => {
                    this.$emit('onFail', item);
                });
            }
            if (this.autoUpload && this.fileList.length) {
                this.submit();
            }
        },
        onSucc (file) {
            this.$emit('onSucc', file);
            console.log('成功', file);
        },
        onFail (file) {
            this.$emit('onFail', file);
            console.log('失败', file);
        },
        // 上传
        submit () {
            // this.prepare();
            return this.uploadQuene();
        },

        uploadQuene () {
            // 并发上传
            let concurrency = 5;
            if (this.uploadingList.length < concurrency && this.readyList.length > 0) {
                let newNumber = concurrency - this.uploadingList.length;
                for (var i = 0; i < this.fileList.length && i < newNumber; i++) {
                    this.prepare(this.fileList[i]);
                }
            }
            return this.fileList;
        },

        // 初始化参数
        async prepare (fileInfo) {
            // let fileInfo = this.fileList[0];
            if (!fileInfo) {
                return;
            }
            const rawFile = fileInfo.rawFile;
            fileInfo.progress = 0;
            fileInfo.status = 'getMd5';
            const showMD5Progress = rawFile.size > oneMB * 20; // 文件大于20M显示解析MD5的过程
            if (showMD5Progress) {
                fileInfo.tips = '正在计算文件md5，请稍等…';
            } else {
                fileInfo.tips = '文件正在上传，请稍等…';
            }

            // this.rawFile = rawFile;
            fileInfo.md5 = await this.getMd5(fileInfo, progress => {
                // if (showMD5Progress) {
                //     fileInfo.progress = Math.floor(progress * 1000) / 10;
                // }
            });
            this.bmf = null;
            if (!fileInfo.md5) {
                fileInfo.status = 'fail';
                fileInfo.tips = 'md5解析出错，请重试';
                return;
            } else if (!this.fileList.find(f => f.md5 === fileInfo.md5)) {
                return;
            }
            if (!showMD5Progress) {
                this.getUploadSts(fileInfo);
            } else {
                setTimeout(() => {
                    this.getUploadSts(fileInfo);
                }, 300);
            }
        },
        // 获取上传sts凭证
        getUploadSts (fileInfo) {
            // let fileInfo = this.fileList[0];
            if (!fileInfo) {
                return;
            }

            const fileName = fileInfo.rawFile.name;
            const fileSize = fileInfo.rawFile.size;
            const mode = fileInfo.options.uploadModeType.split('/');
            const param = {
                type: mode[1],
                typeGroup: mode[0],
                fileItems: [{
                    fileMd5: fileInfo.md5,
                    fileSize: fileSize,
                    fileName: fileName,
                }],
            };

            if (this.uploadUrl) api4.apis.getUploadSts.url = this.uploadUrl + '/getUploadSts';

            // credentials签名授权数据
            api4.getUploadSts(param).then(res => {
                if (res.errcode === 0) {
                    fileInfo.status = 'uploading';
                    fileInfo.credentials = Object.assign(res.data.credentials, { host: res.data.host });
                    fileInfo.result = res.data.items[0];
                    this.executeAliUpload(fileInfo);
                }
            });
        },

        // 执行阿里直传
        async executeAliUpload (fileInfo) {
            // let fileInfo = this.fileList[0];
            const objectKey = fileInfo.result.ossPath;

            if (!fileInfo) return;
            if (fileInfo.result.flag === 'finish') { // 已上传完成的，直接设置为已完成
                this.uploadSucc(fileInfo);
            } else {
                const host = fileInfo.credentials.host;
                const hostArray = host.split('.');
                fileInfo.client = new window.OSS({
                    // 将<YOUR_BUCKET>设置为OSS Bucket名称。
                    bucket: hostArray[0].split('//')[1],
                    // 将<YOUR_REGION>设置为OSS Bucket所在地域，例如region: 'oss-cn-hangzhou'。
                    region: hostArray[1].replace('-internal', ''),
                    authorizationV4: true,
                    secure: true,
                    accessKeyId: fileInfo.credentials.accessKeyId,
                    accessKeySecret: fileInfo.credentials.accessKeySecret,
                    stsToken: fileInfo.credentials.securityToken,
                });

                fileInfo.options.cancel = () => {
                    fileInfo.status = 'cancel';
                    fileInfo.isPaused = true;
                };

                if ((fileInfo.result.flag === 'continue')) { // 继续上传的，获取上一次的position
                    try {
                    // 1. 获取当前文件大小（追加位置）
                        const headResult = await fileInfo.client.head(objectKey);
                        fileInfo.currentPosition = Number(headResult.res.headers['content-length']) || 0;
                        console.log(`当前文件大小: ${fileInfo.currentPosition} bytes`);
                    } catch (err) {
                        fileInfo.currentPosition = 0;
                        console.log('文件不存在:', err);
                    }
                } else {
                    fileInfo.currentPosition = 0;
                }

                this.startAppend(fileInfo); // 开始追加上传
            }
        },

        async startAppend (fileInfo) {
            let fileReader;
            const CHUNK_SIZE = 1024 * 1024 * 10; // 10M
            const objectKey = fileInfo.result.ossPath;
            fileReader = new FileReader();

            // 2. 分片读取文件
            let blob;
            if (fileInfo.currentPosition === 0) {
                blob = fileInfo.rawFile.slice(0, CHUNK_SIZE);
            } else {
                blob = fileInfo.rawFile.slice(fileInfo.currentPosition, fileInfo.currentPosition + CHUNK_SIZE);
            }

            // 3. 执行追加上传
            fileReader.onload = async () => {
                try {
                    const result = await fileInfo.client.append(
                        objectKey,
                        new Blob([fileReader.result]),
                        {
                            position: fileInfo.currentPosition,
                        }
                    );

                    console.log('追加成功:', result);
                    fileInfo.currentPosition += blob.size;

                    if (fileInfo.isPaused) {
                        console.log('上传已暂停，当前位置：', fileInfo.currentPosition);
                        return; // 如果暂停，直接退出，不再继续
                    }

                    // 递归处理剩余部分
                    if (fileInfo.currentPosition < fileInfo.rawFile.size - 1) {
                        fileInfo.status = 'uploading';
                        fileInfo.progress = (Math.round(fileInfo.currentPosition / fileInfo.rawFile.size * 1000) / 10).toFixed(1);
                        console.log(`文件名：${fileInfo.rawFile.name}，进度：`, fileInfo.progress);
                        this.startAppend(fileInfo);
                    } else {
                        console.log('文件追加完成！');
                        if (this.uploadUrl) api4.apis.finishStsUpload.url = this.uploadUrl + '/finishStsUpload';
                        const finish = await api4.finishStsUpload([fileInfo.result.id]);

                        if (finish.errcode === 0) {
                            this.uploadSucc(fileInfo);
                            this.SubmitMediaTask(fileInfo); // 处理媒体转换
                        } else {
                            console.log('提交完成接口出错---', finish.errmsg);
                            fileInfo.status = 'fail';
                            fileInfo.tips = '上传失败';
                        }
                    }
                } catch (err) {
                    fileInfo.status = 'fail';
                    fileInfo.tips = '上传失败';
                    console.log('追加失败:', err);
                }
            };

            fileReader.readAsArrayBuffer(blob);
        },

        // 设置上传成功状态，并继续下一个文件上传
        async uploadSucc (fileInfo) {
            fileInfo.progress = 100;
            fileInfo.status = 'succ';
            fileInfo.tips = '文件上传成功';
            fileInfo.downUrl = fileInfo.result.fileUrl + '?withOriginName=true&download=true';
            fileInfo.url = fileInfo.result.fileUrl;
            if (this.readyList.length) { // 有未上传的，继续上传下一个文件
                let nextItemFile = this.getReadyFile();
                nextItemFile && this.prepare(nextItemFile);
            }
            this.onSucc(fileInfo);
        },

        getReadyFile () {
            let nextItemFile = this.fileList.find(item => { return item.status === 'ready'; });
            console.log('nextItemFile', nextItemFile);
            return nextItemFile;
        },

        // 有配置媒体转换，提交媒体转换任务
        SubmitMediaTask (fileInfo) {
            // 触发多媒体上传
            if (fileInfo.options.multimedia) {
                const name = fileInfo.rawFile.name;
                let extName = name.substring(name.lastIndexOf('.') + 1);
                extName = extName.toLowerCase();

                if (['ppt', 'pptx', 'doc', 'docx'].includes(extName)) fileInfo.options.multimedia.fileType = 'office';
                else if (['pdf'].includes(extName)) fileInfo.options.multimedia.fileType = 'pdf';

                api4.SubmitMediaTask({
                    'projectCode': 'teach_resource',
                    'taskType': 1,
                    'userId': window.yxpapi.store.getters['global/userId'],
                    'fileId': fileInfo.result.fileId,
                    'accessMode': 1,
                    'accessPath': fileInfo.result.filePath,
                    'fileSize': fileInfo.rawFile.size,
                    'fileMd5': fileInfo.md5,
                    'action': fileInfo.options.multimedia,
                });
            }
        },
        // 计算md5
        getMd5 (itemFile) {
            // let i = 0; // 计时器
            // let sizePerSecond = 20 * 1024 * 1024 / 10; // 预计每秒处理容量，每秒20M
            return new Promise((resolve, reject) => {
                // let getMd5Timer = setInterval(function () {
                //     i++;
                //     let progress = sizePerSecond * i / itemFile.rawFile.size;
                //     progress = progress > 1 ? 1 : progress;
                //     itemFile.progress = (Math.round((progress * 0.1 * 10000)) / 100).toFixed(1);
                //     // console.log('md5 progress', progress, itemFile.progress);
                // }, 100);

                // 计算md5
                window.browserMD5File(itemFile.rawFile, (err, md5) => {
                    // getMd5Timer && clearInterval(getMd5Timer);
                    if (err) {
                        resolve({ 'status': false }, err);
                    } else {
                        // itemFile.progress = (Math.round(0.1 * 10000) / 100).toFixed(1);
                        resolve(md5);
                    }
                });
            });
        },

        /**
         * 随机生成id
         * @param n 默认32位
         * @returns {string}
         */
        randomId (n = 32) {
            let s = '';
            Array.from({ length: n }).forEach((v, i) => {
                let r = Math.floor(Math.random() * 36);
                if (r < 10) {
                    s += r;
                } else {
                    s += String.fromCharCode(r + 87);
                }
                if ([7, 11, 15, 19].includes(i)) s += '-';
            });
            return s;
        },
        /**
          *继续上传或者重新上传
        */
        retryUpload (fileInfo) {
            if (fileInfo.isPaused) fileInfo.isPaused = false; // 取消暂停
            this.startAppend(fileInfo);
        },
    },

};

</script>

<style lang="scss" scoped>
  .yxp-uploader{
        .btn{
            outline: none;
            &.upload-btn{
                width:80px;
                border: none;
                padding:4px 10px;
                border-radius: 4px;
                cursor: pointer;
                background-color:#2FD095;
                color:#fff;
            }
            &.upload-btn:hover{
                background-color:rgb(28, 151, 106);
            }
        }
        input{
            display:none;
        }
    }
</style>
